<template>
  <section class="my-16 px-4 max-w-screen-xl mx-auto">
    <h2>{{ title }}</h2>
    <div class="md:flex md:flex-wrap md:flex-shrink md:justify-center">
      <article
        v-for="section in list"
        :key="section.pk"
        class="border rounded mx-auto px-4 my-6 max-w-sm md:mx-3"
      >
        <div class="text-left px-4 py-6 h-full flex flex-col justify-between">
          <div class="flex-grow">
            <div class="text-5xl font-bold mb-4">{{ section.order }}</div>
            <div class="text-xl font-bold mb-2">{{ section.title }}</div>
            <div class="pb-12">
              <p>{{ section.description }}</p>
            </div>
          </div>

          <div
            class="pt-4 p-2 flex justify-between items-center border-t-2 border-black"
          >
            <div class="font-bold pr-6">
              <span class="pr-2">
                <BaseIcon :name="['far', 'calendar-plus']" />
              </span>
              {{ section.date }}
            </div>
            <router-link
              :to="{ name: urlName, params: { slug: section.slug } }"
              class="text-sm cursor-pointer font-bold text-secondary-500 transitions-all duration-200 px-2 py-1 rounded hover:bg-secondary-100"
            >
              Ver sesiones
            </router-link>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    list: {
      type: Array,
      required: true,
    },

    urlName: {
      type: String,
      required: true,
    },
  },
}
</script>
